import { D } from "@mobily/ts-belt";
import PropTypes from "prop-types";
import { useFilters } from "../utils";
import { Typography } from "../../../themeV2";
import s from "./SortSelect.module.css";

export default function SortSelect({ filter, setFilter }) {
  const { filters } = useFilters();

  return (
    <div className={s.wrapper}>
      <Typography
        variant="label-lg"
        color="variant"
        weight="bold"
        as="label"
        htmlFor="browse-shops-sort"
        className={s.label}
      >
        Sort
      </Typography>
      <select
        id="browse-shops-sort"
        className={s.select}
        value={filter.order}
        onChange={(e) => {
          setFilter(D.merge({ cursor: "", order: e.target.value }));
        }}
      >
        {filters.sort.map((option) => (
          <option key={option.id} value={option.id}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
}

SortSelect.propTypes = {
  filter: PropTypes.shape({
    order: PropTypes.string.isRequired,
  }).isRequired,
  setFilter: PropTypes.func.isRequired,
};
